import clsx from "clsx";
import Image from "next/image";
import Link from "next/link";

export const SecondBanner = () => {
  const images = [
    "/images/tags/tag_esportes.png",
    "/images/tags/tag_humor.png",
    "/images/tags/tag_musica.png",
    "/images/tags/tag_natureza.png",
    "/images/tags/tag_muito_mais.png",
  ];

  return (
    <Link href="/busca">
      <div className="relative h-[104vw] max-h-[25.25rem] w-full">
        {/* ===== < lg: layout empilhado — arte por inteiro (contain; traços auto-contidos) em cima
            e bloco de cor sólida embaixo com o texto. Em telas mais largas as sobras viram cor sólida.
            PLACEHOLDER: trocar a URL da arte pelo asset novo do design quando chegar. ===== */}
        <div className="flex h-full w-full flex-col bg-[#EFF3F4] lg:hidden">
          <div
            className="w-full flex-1 bg-center bg-no-repeat"
            style={{
              backgroundImage: "url('/images/home/main_carousel/banner_mobile_temas.png')",
              backgroundSize: "min(60%, 288px) auto",
            }}
          />
          <div className="px-4 pb-3 pt-1 text-center">
            <p className="secondary-font text-[1.375rem] font-extrabold !leading-[1.5rem] text-banner-dark">
              PRODUTOS PARA TODOS OS ESTILOS
            </p>
            <p className="secondary-font mx-auto my-1 w-2/3 text-[0.6875rem] font-light !leading-[0.875rem] tracking-[0.075rem] text-[#3a3f45]">
              SEUS TEMAS PREFERIDOS ESTÃO AQUI NA REMIX!
            </p>
          </div>
        </div>

        {/* ===== ≥ lg: layout panorâmico atual (arte larga + texto sobreposto à esquerda) ===== */}
        <div className="hidden lg:absolute lg:inset-0 lg:block">
          <div className="absolute left-0 top-0 h-full w-1/2 bg-[#C6D0D8]" />
          <div className="absolute right-0 top-0 h-full w-1/2 bg-[#EFF3F4]" />
          <div className="relative z-0 flex h-full w-full flex-col bg-[url('/images/home/main_carousel/banner_desktop_temas.png')] bg-[length:auto_100%] bg-center bg-no-repeat">
            <div className="z-10 ml-8 flex h-full w-2/5 flex-col justify-center px-3">
              <div className="flex flex-col">
                <p className="secondary-font text-center text-[2.75rem] font-bold leading-10 text-banner-dark">
                  TUDO EM UM SÓ LUGAR!
                </p>
                <p className="secondary-font mb-4 mt-2 text-center text-[1.275rem] font-light tracking-widest text-banner-gray">
                  O TEMA QUE VOCÊ PROCURA ESTÁ AQUI NA REMIX.
                </p>
              </div>
              <div className="w-full font-bold">
                <ul className="flex w-full list-none flex-row flex-wrap justify-center gap-2 pl-0">
                  {images.map((image, index) => (
                    <li
                      key={index}
                      className={clsx("mr-4 flex items-center", {
                        "!mr-0": index === images.length - 1,
                      })}
                    >
                      <Image
                        src={image}
                        alt="Theme tag"
                        className="mr-1 h-auto w-[120px]"
                        width={120}
                        height={120}
                        sizes="120px"
                      />
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};
